import { Component, HostBinding, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CountryRestrictionService } from '@app/country-restriction/country-restriction.service';
import { CountryRegistrationRestrictionService } from '@app/country-restriction/country-registration-restriction.service';
import { AuthenticationService } from '@app/core';
import { AppService } from '@app/core/app.service';
import { filter, map, mergeMap } from 'rxjs/operators';

@Component({
  selector: 'app-template',
  templateUrl: './template.template.html',
  styleUrls: ['./template.template.scss'],
})
export class TemplateComponent implements OnInit, OnDestroy {
  _routerSub: Subscription;
  chatVisibility$: Subscription = null;
  classList: string[] = [];

  scrollTop: string = '';

  showFooterInCustom: boolean = false;

  showHero: boolean = false;
  showSubHeader: boolean = true;
  usesCustomTemplate: boolean = false;

  @Input() class: string = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.class,
      this.showHero ? 'hero-image-margin' : '',
      this.showSubHeader ? 'sub-header-margin' : '',
      this.usesCustomTemplate ? 'custom-template' : '',
      ...this.classList,
    ].join(' ');
  }

  constructor(
    public countryRestrictionService: CountryRestrictionService,
    public countryRegistrationRestrictionService: CountryRegistrationRestrictionService,
    public router: Router,
    private renderer: Renderer2,
    private activatedRoute: ActivatedRoute,
    private auth: AuthenticationService,
    private appService: AppService
  ) {
    const onNavigationEnd = this.router.events.pipe(filter(event => event instanceof NavigationEnd));

    onNavigationEnd
      .pipe(
        map(() => {
          let route = this.activatedRoute;
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter(route => route.outlet === 'primary'),
        mergeMap(route => route.data)
      )
      .subscribe(event => {
        const hero = event['hero'];
        const subHeader = event['subHeader'];
        this.showFooterInCustom = !!event['showFooterInCustom'];
        if (event['classList']) {
          this.classList = event['classList'];
        } else {
          this.classList = [];
        }
        this.usesCustomTemplate = this.appService.getFlag('customTemplate');
      });
  }

  ngOnInit() {
    this.trackRouterChanges();
  }

  ngOnDestroy() {
    if (this._routerSub) {
      this._routerSub.unsubscribe();
    }
    if (this.chatVisibility$) {
      this.chatVisibility$.unsubscribe();
    }
  }

  public useCustomTemplate(): boolean {
    return this.appService.getFlag('customTemplate');
  }

  public allowChat(): boolean {
    return this.appService.getFlag('allowChat');
  }

  private trackRouterChanges() {
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        if (window.innerWidth <= 991) {
          window.scrollTo(0, 0);
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/template.component.ts